<template>
  <div>
    <vx-card>
      <ListDivisoes :subjectPermission="subjectPermission"></ListDivisoes>
    </vx-card>
  </div>
</template>

<script>
import ListDivisoes from "./../../lists/ListDivisoes";

export default {
  data() {
    return {
      subjectPermission: "Assessoria",
    };
  },
  methods: {},
  components: {
    ListDivisoes,
  },
};
</script>
